import { render, staticRenderFns } from "./payment-methods.vue?vue&type=template&id=71a0d2b8&scoped=true"
import script from "./payment-methods.vue?vue&type=script&lang=js"
export * from "./payment-methods.vue?vue&type=script&lang=js"
import style0 from "./payment-methods.vue?vue&type=style&index=0&id=71a0d2b8&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/mobile/payment-methods.less?vue&type=style&index=1&id=71a0d2b8&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a0d2b8",
  null
  
)

export default component.exports